<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" v-html="options.title"></h4>
                </div>
                <div class="modal-body">
                    <p class="confirmation-template"></p>
                </div>
                <div class="modal-footer">
                    <div class="btn-group">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click="cancel">{{options.cancel}}</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="confirm" autofocus>{{options.confirm}}</button>
                    </div>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
    let Vue = require('vue/dist/vue.js');

    export default {
        name: 'confirmation-modal',
        data() {
            return {
                confirm_callback: null,
                cancel_callback: null,
                options: {},
                vm : null,
                showing: false,
            };
        },
        methods: {
            hide(e) {
                if(this.showing)
                {
                    this.cancel();
                }
            },
            confirm() {
                if(this.confirm_callback !== null)
                    this.confirm_callback();
                this.showing = false;
            },
            cancel() {
                if(this.cancel_callback !== null)
                    this.cancel_callback();
                this.showing = false;
            },
            open(args)
            {
                this.showing = true;

                this.options = {
                    title: "Confirm",
                    message: "Are you sure?",
                    confirm: "OK",
                    cancel: "Cancel",
                    data: {}
                };

                for(let i in this.options)
                {
                    if(this.options.hasOwnProperty(i))
                    {
                        if(typeof args.options != 'undefined' && typeof args.options[i] != 'undefined')
                        {
                            this.options[i] = args.options[i];
                        }
                    }
                }

                if(typeof args.confirm_callback != 'undefined')
                {
                    this.confirm_callback = args.confirm_callback;
                }
                if(typeof args.cancel_callback != 'undefined')
                {
                    this.cancel_callback = args.cancel_callback;
                }

                this.$nextTick(() => {
                    if(this.vm !== null)
                    {
                        this.vm.$destroy();

                        $(this.vm.$el).remove();
                    }

                    let el = $('<div>');
                    $(this.$el).find('.confirmation-template').append(el);

                    this.vm = new Vue({
                        functional: true,
                        template: '<div>' + this.options.message + '</div>',
                        data: this.options.data,
                    }).$mount(el.get()[0]);
                });

                $(this.$el).modal('show');
            },
            shown() {
                $(this.$el).find("[autofocus]").focus();
            }
        },
        mounted() {
            this.$root.bus.$on('confirmation-modal:open', this.open);
            $(this.$el).modal({show:false});
            $(this.$el).on('hide.bs.modal', this.hide);
            $(this.$el).on('shown.bs.modal', this.shown);
        }
    }
</script>

<style>

</style>